export enum EyRangeSelectionLimit {
  Unlimited,
  Min,
  Max,
  Range,
  Exactly,
}
